module.exports = __webpack_public_path__ + "img/dianliangziben.d11e0858.png";